@import "src/styles/common/_colors.scss";

.filterBody {
  background-color: $gray-variant;
  max-height: 700px;
}

.filterFooter {
  position: relative !important;
}

.clearFilter {
  font-size: 12px;
  margin-left: 5px;
  top: 50px;
}

.filterCloseButtom {
  margin-left: 12px;
}

.dropdown {
  a {
    color: $white;
  }

  .dropdownToggle {
    font-size: 12px;
    line-height: 10px !important;
    font-size: 11px;
    color: $white;
    border-radius: 3px;
    background: none !important;

    &.noBorder {
      text-shadow: none;
      box-shadow: none;
      border: none;
      padding: 0px;
    }
    &:hover {
      color: $label;
    }
  }

  .dropdownToggle::after {
    content: unset !important;
  }

  .dropdownMenu {
    font-size: 14px !important;
    background-color: $black;
    border: 1px solid $mightnight-black;
    border-radius: 6px;
    box-shadow: 0 5px 10px $smoke-black;
    background-clip: padding-box;

    a {
      display: block;
    }

    input {
      font-size: 12px;
      width: -webkit-fill-available;
      margin: 0 10px 0 10px;
    }

    .dropdownItem {
      line-height: 20px;
      color: $white;
      font-size: 12px;
      padding: 0 10px 0 10px;
    }

    .dropdownItem.disabled {
      color: $smoke-white;
      pointer-events: none;
    }

    .dropdownItem.hidden {
      display: none;
    }

    .dropdownItem:hover,
    .dropdownItem:focus {
      background-color: $dark-green !important;
      border-radius: 3px !important;
    }

    .dropdownDivider {
      background-color: $white;
      height: 1px;
      margin: 9px 1px;
    }
  }
}

.tableFilterContainer {
  min-width: 200px;
}

.filterColor {
  color: $light-green-variant;
}

.clearAll {
  cursor: pointer;
}

.icon_size {
  font-size: 10px;
  margin-right: 6px;
}

.filterContent {
  margin: 5px 13px;
  cursor: pointer;
}

.filterContent:hover {
  .clearFilter {
    text-decoration: underline;
  }
}

.customfilter {
  position: absolute !important;
  max-height: 900px !important;
  animation-name: filterAnimation;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}

@keyframes filterAnimation {
  from {
    top: -25%;
  }

  to {
    top: 40px;
  }
}

.filterDateWrapper {
  padding: 10px 10px 5px 10px;
}

.spinner {
  display: inline-block;
  width: 14px;
  margin-right: 4px;
  div {
    span {
      font-size: 14px !important;
    }
  }
}
